import { Element } from "@siteimprove/alfa-dom";
import { Context } from "../../../context.js";
import { PseudoClassSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#enableddisabled}
 * {@link https://html.spec.whatwg.org/multipage#selector-disabled}
 */
export class Disabled extends PseudoClassSelector {
    static of() {
        return new Disabled();
    }
    constructor() {
        super("disabled");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context = Context.empty()) {
        return Element.isActuallyDisabled(element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Disabled) {
    Disabled.parse = PseudoClassSelector.parseNonFunctional("disabled", Disabled.of);
})(Disabled || (Disabled = {}));
//# sourceMappingURL=disabled.js.map